import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@mui/material'
import { currentMarking, initialMarking } from '../../../../../card/LearningGrowth/Styles'
import { FormControlLabel, Switch } from '@mui/material'
import { useByStudent } from '../ByStudentContext/ByStudentContext'

const LegendLearningGrowth = () => {
  const { isLoadingUser, viewLG, setViewLG } = useByStudent()
  if (isLoadingUser) return <></>

  const width = 10

  return (
    <div className='px-4 flex items-center bg-primary h-full'>
      <FormControlLabel
        value={viewLG}
        name='type-learning-growth'
        control={
          <Switch
            color='secondary'
            size='small'
            checked={viewLG}
            onChange={(e) => setViewLG(e.target.checked)}
          />
        }
        label={<Typography className='text-primary-foreground'>{viewLG ? 'Column ' : 'Row '}</Typography>}
      />
      <div className='flex flex-col gap-2 text-primary-foreground'>
        <div className='flex items-center gap-2 h-5'>
          <div style={{ width, height: width }} className=' flex items-center justify-center rounded-full'>
            <FontAwesomeIcon icon={initialMarking} size='lg' />
          </div>
          <Typography className='text-primary-foreground text-xs text-nowrap'>Starting Level</Typography>
        </div>
        <div className='flex items-center gap-2 h-5'>
          <div style={{ width, height: width }} className=' flex items-center justify-center rounded-full'>
            <FontAwesomeIcon icon={currentMarking} size='lg' />
          </div>
          <Typography className='text-primary-foreground text-xs text-nowrap'>Current Level</Typography>
        </div>
      </div>
    </div>
  )
}

export default LegendLearningGrowth
